import axios from "axios";
import {REACT_APP_BASE_URL} from "../index";

export const getTermsOfUse = () => {
    return axios.get(`${REACT_APP_BASE_URL}/terms-and-conditions`);
}
